import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeVersionPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Version d'un runtime et ses dépendances (porting README #43). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/versions/$versionId')({
  component: RuntimeVersionRoute,
});

function RuntimeVersionRoute() {
  const { tenant, runtimeId, versionId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: runtimeId, mono: true },
        { label: versionId, mono: true },
      ]}
    >
      <RuntimeVersionPage tenantId={tenant} runtimeId={runtimeId} versionId={versionId} />
    </ConsoleShell>
  );
}
